var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.5 253h-10c-11.046 0-20 8.954-20 20s8.954 20 20 20h10c11.046 0 20-8.954 20-20s-8.954-20-20-20zM335.5 173h-127c-11.046 0-20 8.954-20 20s8.954 20 20 20h127c11.046 0 20-8.954 20-20s-8.954-20-20-20z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.389 472H108.5c-22.056 0-40-17.944-40-40V80c0-22.056 17.944-40 40-40h245.889c22.056 0 40 17.944 40 40v113c0 11.046 8.954 20 20 20s20-8.954 20-20V80c0-44.112-35.888-80-80-80H108.5c-44.112 0-80 35.888-80 80v352c0 44.112 35.888 80 80 80h194.889c11.046 0 20-8.954 20-20s-8.954-20-20-20z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5 333h-10c-11.046 0-20 8.954-20 20s8.954 20 20 20h10c11.046 0 20-8.954 20-20s-8.954-20-20-20zM335.5 93h-127c-11.046 0-20 8.954-20 20s8.954 20 20 20h127c11.046 0 20-8.954 20-20s-8.954-20-20-20zM427.135 359.954h-18.327c-8.963 0-16.255-7.422-16.255-16.545v-2.703c0-8.954 6.988-15.706 16.255-15.706h17.33c5.094 0 10.362 3.41 10.362 9.116 0 11.046 8.954 20 20 20s20-8.954 20-20c0-23.969-17.7-43.97-41.02-48.255V273c0-11.046-8.954-20-20-20s-20 8.954-20 20v13.548c-9.898 2.336-18.966 7.271-26.319 14.467-10.71 10.479-16.608 24.576-16.608 39.691v2.703c0 31.179 25.235 56.545 56.255 56.545h18.327c9.023 0 16.365 7.31 16.365 16.295v9.5c0 8.694-7.035 15.251-16.365 15.251H397.35c-5.638 0-9.89-4.036-9.89-9.389 0-11.046-8.954-20-20-20s-20 8.954-20 20c0 13.396 5.25 25.898 14.783 35.205 8.928 8.716 20.67 13.689 33.237 14.14V492c0 11.046 8.954 20 20 20s20-8.954 20-20v-11.583c27.511-3.844 48.02-26.472 48.02-54.668v-9.5c0-31.041-25.285-56.295-56.365-56.295zM295.5 373c11.046 0 20-8.954 20-20s-8.954-20-20-20h-87c-11.046 0-20 8.954-20 20s8.954 20 20 20h87zM138.5 173h-10c-11.046 0-20 8.954-20 20s8.954 20 20 20h10c11.046 0 20-8.954 20-20s-8.954-20-20-20zM355.5 273c0-11.046-8.954-20-20-20h-127c-11.046 0-20 8.954-20 20s8.954 20 20 20h127c11.046 0 20-8.954 20-20zM138.5 93h-10c-11.046 0-20 8.954-20 20s8.954 20 20 20h10c11.046 0 20-8.954 20-20s-8.954-20-20-20z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.fdbb6a70013eccb0cc0ce02d92584bbf.svg";
export { ForwardRef as ReactComponent };